import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
})
export class PasswordInputComponent {
  // @ViewChild('input') inputElement!: ElementRef;
  @Input() control!: FormControl;
  @Input() matchValue!: string;
  @Input() label: string = '';
  @Input() ControlId: string = 'inputPassword';
  @Input() login = false;
  @Input() placeholder: string = '';
  @Output() currentValueChange = new EventEmitter<string>();
  @Output() enterPressed = new EventEmitter<void>();
  showPassword = false;
  get labelFirst() {
    return this.label.split(' ')[0];
  }
  emitValue() {
    this.currentValueChange.emit(this.control.value);
  }

  onEnterPressed(ev: Event) {
    ev.stopPropagation();
    this.enterPressed.emit();
  }
  constructor(
    private renderer: Renderer2
  ) { }
  ngAfterViewInit() {
    // Set autofocus on the input element
   // this.renderer.selectRootElement(this.inputElement.nativeElement).focus();
  }
}
